module.exports = __webpack_public_path__ + "img/home-service-turang.77b10e34.png";